// AboutCashQuin.tsx
import * as React from "react";
import {
  Box,
  Container,
  Grid,
  Heading,
  Stack,
  Text,
  SimpleGrid
 ,
} from "@chakra-ui/react";
import Header from "components/reusables/Header/Header";
import Footer from "../Footer/Footer";

export const AboutCashQuin: React.FC = () => {
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
  return (
    <>
      <Header />
      <Box bg="bg.canvas" py={{ base: 10, md: 16 }}>
        <Container maxW="6xl">
          {/* Main heading */}
          <Stack gap={4} textAlign="center" mb={{ base: 10, md: 14 }}>
            <Heading as="h2" size="lg">
              About CashQuin
              <Text fontSize="sm" color="fg.muted">
                <Text as="span" fontWeight="semibold">
                  CashQuin is own by Webtooth Techno LLP
                </Text>
              </Text>
            </Heading>

            <Text maxW="3xl" mx="auto" color="fg.muted" fontSize="sm">
              We are a team of passionate developers, designers, and strategists
              who believe in the power of technology to transform businesses.
              Our journey began with a simple idea: create digital solutions
              that not only solve real problems, but also inspire and engage
              customers.
            </Text>
          </Stack>

          <Grid
            templateColumns={{ base: "1fr", md: "1.1fr 0.9fr" }}
            gap={{ base: 10, md: 12 }}
            alignItems="flex-start"
          >
            {/* LEFT: Story + Mission */}
            <Stack gap={8}>
              {/* Our Story */}
              <Box
                bg="bg.surface"
                p={{ base: 6, md: 7 }}
                rounded="2xl"
                boxShadow="sm"
              >
                <Heading as="h3" size="md" mb={3}>
                  Our Story
                </Heading>
                <Text fontSize="sm" color="fg.muted">
                  CashQuin was born from the need to make financial workflows
                  simpler, faster, and more secure. From day one, our focus has
                  been on building digital products that feel modern and
                  trustworthy — whether you&apos;re a startup, a growing
                  business, or an enterprise.
                </Text>
                <Text mt={3} fontSize="sm" color="fg.muted">
                  Today, we are a leading provider of digital solutions that
                  transform how businesses operate and engage with their
                  customers, with a strong focus on reliability and real-world
                  performance.
                </Text>
              </Box>

              {/* Mission */}
              <Box
                bg="bg.surface"
                p={{ base: 6, md: 7 }}
                rounded="2xl"
                boxShadow="sm"
              >
                <Heading as="h3" size="md" mb={3}>
                  Our Mission
                </Heading>
                <Text fontSize="sm" color="fg.muted">
                  Our mission is simple:{" "}
                  <Text as="span" fontWeight="semibold">
                    To empower businesses with innovative technology solutions
                    that drive growth and success.
                  </Text>{" "}
                  We are committed to delivering high-quality, reliable, and
                  scalable platforms that help our clients achieve their
                  business goals.
                </Text>
              </Box>
            </Stack>

            {/* RIGHT: Values + Skills */}
            <Stack gap={8}>
              {/* Values */}
              <Box
                bg="bg.surface"
                p={{ base: 6, md: 7 }}
                rounded="2xl"
                boxShadow="sm"
              >
                <Heading as="h3" size="md" mb={3}>
                  What We Stand For
                </Heading>

                <SimpleGrid columns={{ base: 2, md: 2 }} gap={3} mb={3}>
                  {[
                    "Innovation",
                    "Integrity",
                    "Excellence",
                    "Security",
                    "Customer-Centricity",
                  ].map((item) => (
                    <Box key={item}>
                      <Text fontSize="sm" fontWeight="semibold">
                        {item}
                      </Text>
                    </Box>
                  ))}
                </SimpleGrid>

                <Text fontSize="sm" color="fg.muted">
                  Every product we ship and every integration we design is
                  guided by these principles — from architecture decisions to
                  the last pixel in the UI.
                </Text>
              </Box>

              {/* Skills / Capabilities */}
              {/* <Box bg="bg.surface" p={{ base: 6, md: 7 }} rounded="2xl" boxShadow="sm">
              <Heading as="h3" size="md" mb={3}>
                Our Skills
              </Heading>
              <Text fontSize="sm" color="fg.muted">
                The team behind CashQuin (Astrox Hub) is a leading provider of
                digital solutions that transform the way businesses operate and
                engage with their customers. Our experts specialize in:
              </Text>

              <SimpleGrid
                mt={4}
                columns={{ base: 1, sm: 2 }}
                gap={3}
                fontSize="sm"
              >
                <Text>• Web &amp; mobile app development</Text>
                <Text>• API development &amp; integrations</Text>
                <Text>• ERP &amp; back-office solutions</Text>
                <Text>• Cloud computing &amp; DevOps</Text>
                <Text>• IT consulting &amp; architecture</Text>
              </SimpleGrid>

              <Separator my={4} />
              <Text fontSize="sm" color="fg.muted">
                <Text as="span" fontWeight="semibold">
                  CashQuin is own by webtooth techno llp.
                </Text>
              </Text>
            </Box> */}
            </Stack>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
};
